import { _packBits } from './utils';
var _PdfExternal = /** @class */ (function () {
    function _PdfExternal(directReference, indirectReference, dataValueDescriptor, encoding) {
        if (encoding && directReference && dataValueDescriptor && indirectReference) {
            this._directReference = directReference;
            this._indirectReference = indirectReference;
            this._dataValueDescriptor = dataValueDescriptor;
            this._encoding = encoding;
        }
        else {
            throw new Error('Invalid constructor arguments');
        }
    }
    _PdfExternal.prototype._toString = function () {
        var result = 'EXTERNAL { ';
        if (this._directReference) {
            result += "directReference " + this._directReference.toString() + " ";
        }
        if (this._indirectReference) {
            result += "indirectReference " + this._indirectReference.toString() + " ";
        }
        if (this._dataValueDescriptor) {
            result += "dataValueDescriptor '" + this._dataValueDescriptor + "' ";
        }
        if (this._encoding instanceof Uint8Array) {
            result += "octet-aligned " + Array.from(this._encoding).map(function (byte) { return byte.toString(16); }).join('') + " ";
        }
        else if (this._encoding instanceof Uint8ClampedArray) {
            result += "arbitrary " + this._encoding.toString() + " ";
        }
        else {
            result += "single-ASN1-type " + this._encoding.toString() + " ";
        }
        result += '}';
        return result;
    };
    _PdfExternal.prototype._toJson = function () {
        var encoding; // eslint-disable-line
        if (this._encoding instanceof Uint8Array) {
            encoding = Array.from(this._encoding)
                .map(function (byte) { return byte.toString(16); })
                .join('');
        }
        else if (this._encoding instanceof Uint8ClampedArray) {
            var bits = this._encoding;
            encoding = { length: bits.length,
                value: Array.from(_packBits(bits))
                    .map(function (byte) { return byte.toString(16); })
                    .join('')
            };
        }
        return {
            directReference: this._directReference,
            indirectReference: this._indirectReference,
            dataValueDescriptor: this._dataValueDescriptor,
            encoding: encoding
        };
    };
    return _PdfExternal;
}());
export { _PdfExternal };
